
export default function getDistance(LAT1, LONG1, LAT2, LONG2){
  const distance = 2 * 6371000 * Math.asin(Math.sqrt(Math.pow((Math.sin((parseFloat(LAT2) * (3.14159 / 180) - parseFloat(LAT1) * (3.14159 / 180)) / 2)), 2) + Math.cos(parseFloat(LAT2) * (3.14159 / 180)) * Math.cos(parseFloat(LAT1) * (3.14159 / 180)) * Math.sin(Math.pow(((parseFloat(LONG2) * (3.14159 / 180) - parseFloat(LONG1) * (3.14159 / 180)) / 2), 2))));
  const ceilDistance = Math.ceil(distance)
  return ceilDistance;
}